import * as LodashFP from 'lodash/fp'

function formatIcon(format: string) {
  const formatIcons = {
    image: 'image',
    carousel: 'view_carousel',
    slideshow: 'slideshow',
    video: 'videocam',
    promoted_post: 'speaker_phone',
    collection_catalog: 'view_stream',
  }

  return LodashFP.getOr('format_paint', [format], formatIcons)
}

export default formatIcon
